import { Dispatch, SetStateAction } from "react";
import { Dialog, Button } from "@material-tailwind/react";
import { getFileTypes } from "../utils/formatViews";
import { Xmark } from "iconoir-react";
import { PDFViewer } from "./PDFViewer";
interface DialogFilePreviewProps {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    url: string;
}

export const DialogFilePreview: React.FC<DialogFilePreviewProps> = ({
    isOpen,
    setIsOpen,
    url,
}) => {
return (
    <Dialog open={isOpen} size="lg" onOpenChange={setIsOpen}>
        <Dialog.Overlay>
            <Dialog.Content className="relative p-8 pt-16">
                <Button
                    className="absolute top-2 right-2"
                    isPill
                    variant="ghost"
                    color="secondary"
                    onClick={() => setIsOpen(false)}
                >
                    <Xmark className="w-5 h-5" />
                </Button>
                <div className="max-h-[calc(95dvh-3rem-80px)] overflow-y-auto">
                    {getFileTypes(url) === "Image File" ? (
                        <img src={url} alt="Document Preview" className="w-full h-auto" />
                    ) : (
                        <PDFViewer pdfUrl={url} />
                    )}
                </div>
                <div className="flex justify-center">
                    <Button
                        className="mt-4 mx-auto"
                        variant="outline"
                        color="secondary"
                        onClick={() => setIsOpen(false)}
                    >
                        Close
                    </Button>
                </div>
            </Dialog.Content>
        </Dialog.Overlay>
    </Dialog>
);
}
